// extracted by mini-css-extract-plugin
export default {"imageWrapper":"JN-z","hovered":"KN-z","hoverImage":"LN-z","mainImage":"MN-z","imageNoBackground":"NN-z","fullSizeImage":"ON-z"};